<template>
  <v-container class="pa-0">
    <input
      type="file"
      ref="file"
      accept="image/png, image/jpeg"
      @change="getImage"
      style="display: none"
    />

    <v-row no-gutters>
      <v-col>
        <v-avatar size="150" v-if="user">
          <img :src="user.avatar" :key="(user) ? user.updatedAt: null" />
        </v-avatar>
      </v-col>
    </v-row>
    <v-row no-gutters dense class="pl-6">
      <v-col>
        <v-btn
          color="primary"
          @click="$refs.file.click()"
          :loading="btnLoading"
          :disabled="!user || !user.id"
        >Upload</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    user: {
      id: null,
      avatar: null,
      updatedAt: null,
    },
    btnLoading: false,
  }),
  created() {
    this.user = this.value;
  },
  methods: {
    getImage() {
      const reader = new FileReader();
      const { files } = this.$refs.file;

      if (files && files.length > 0) {
        this.btnLoading = true;
        reader.readAsDataURL(this.$refs.file.files[0]);
        reader.onload = () => {
          this.upload(reader.result);
        };
      } else {
        bus.$emit('message', {
          message: 'Falha ao ler o arquivo',
          type: 'error',
        });
      }
    },
    upload(base64Image) {
      const userLogged = this.$store.getters['auth/getUser'];
      const method = userLogged.id === this.value.id
        ? 'patientUser/uploadAvatar'
        : 'patientDependents/uploadAvatar';

      this.$store
        .dispatch(method, {
          patientId: this.user.id,
          base64Image,
        })
        .then((res) => {
          this.user.avatar = res.avatar;
          this.user.updatedAt = res.updatedAt;
          this.$emit('input', this.user);
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
  },
  watch: {
    value(vl) {
      this.user = vl;
    },
  },
  components: {},
};
</script>
